"use client";

import React from "react";
import { MapPin, Phone, Mail, Instagram, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-lg" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function UnitedLifestyleFooter() {
  return <section data-section-id="228069" id="footer" className="bg-background text-foreground pt-20 pb-8 light">
      <div className="container mx-auto px-6 md:px-8 lg:px-12 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 justify-between gap-12 lg:gap-8">
          {}
          <div className="flex flex-col space-y-6">
            <Link to="/">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            
            <p className="text-muted-foreground uppercase text-sm tracking-widest">
              NC General Contractor License #109136
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h4 className="text-lg font-default font-bold tracking-tight uppercase text-foreground">
              Quick Links
            </h4>
            <MenuProvider menu_id="37">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col space-y-6 !items-start">
            <h4 className="text-lg font-default font-bold tracking-tight uppercase text-foreground">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-muted-foreground">
              
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-primary shrink-0" />
                <Link to="tel:2698329698" className="text-primary transition-colors font-default text-2xl tracking-tighter !font-normal hover:text-primary/80">269 832 9698</Link>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-primary shrink-0" />
                <Link to="mailto:contact@emanuelcg.com" className="text-primary transition-colors font-default tracking-tighter !font-thin !text-lg hover:text-primary/80">contact@emanuelcg.com</Link>
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-6 !items-center !justify-start">
            <h4 className="text-lg font-default font-bold tracking-tight uppercase text-foreground">
              Now Serving
            </h4>
            <div className="flex flex-col gap-2 text-sm font-default text-muted-foreground">
              <p>Fayetteville</p>
              <p>Piedmont Triad</p>
              <p>Research Triangle</p>
            </div>
          </div>

          {}
          
        </div>

        {}
        <Separator className="bg-primary/20 my-10 h-px" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-default">
          <p>
            &copy; {new Date().getFullYear()} Emanuel Construction Group. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors duration-300">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors duration-300">
              Terms of Service
            </Link>
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="flex items-center gap-1 text-primary hover:text-primary/80 transition-colors font-bold uppercase">
              Back to Top ↑
            </button>
          </div>
        </div>
      </div>
    </section>;
}